import { WarehouseListPage } from "@/features/warehouse/pages/WarehouseListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/warehouse/")({
  beforeLoad({ context }) {
    if (!context.authAdapter.can({ permissions: ["warehouse.view"] })) {
      throw redirect({ to: "/403" });
    }
  },
  component: WarehouseListPage,
});
